import $ from 'jquery';
window.$ = window.jQuery = $;

import 'bootstrap';

import 'summernote/dist/summernote-lite';

import 'select2';

import 'sweetalert';




$(function () {
    $('.select2').select2({
        theme: "bootstrap-5",
        language:  {
            noResults: function() {
                return "找不到相符的結果";
            },
        },
        allowClear: true
    });
    $('.multiSelect2').select2({
        theme: "bootstrap-5",
    });


    //驗證資料是否有必填
    let $form = $('#frontend-form');
    function focusField(element) {//鎖定未填欄位
        let tabId = $(element).closest('.tab-pane').attr('aria-labelledby')
        $('#' + tabId).tab('show');
        $(window).scrollTop($(element).offset().top - $(window).height() / 2);
        $(element).focus();
    }
    function showValidationMessage(element, message) {//顯示必填通知
        removeValidationMessage();
        $(element).addClass('required-error');
        $('<div>').addClass('required-error-message text-danger position-absolute').html(message).insertAfter(element)
    }
    function removeValidationMessage() {//移除必填通知
        $('.required-error-message').remove();
        $('.required-error').removeClass('required-error');
    }
    $(document.body).on('change','.required-error',function (){//必填未填項目修改後移除通知
        removeValidationMessage();
    });
    $form.on('submit', e => {//表單送出後進行驗證
        // 檢查所有的必填欄位
        let invalid = false;
        $('.required').each((index, ele) => {
            if(!$(ele).val()) {
                invalid = true;
                focusField(ele);
                showValidationMessage(ele, '此欄位必填');
                return false;
            }
        });
        if(invalid) {
            return false;
        }
    });
    $(document.body).on('click','.delete-confirm',e => {
        e.preventDefault();
        let code = '';
        var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
        for (var x = 0; x < 10; x++) {
            var i = Math.floor(Math.random() * chars.length);
            code += chars.charAt(i);
        }
        if(prompt('注意！目前將刪除所選擇項目，此操作無法回覆。 如果仍要繼續動作，請輸入以下代碼： ' + code ) === code) {
            $(e.currentTarget).closest('form').submit();
        }
    });

});